<template>
  <BaseIcon
    name="search"
    :tooltip="
      device.touch
        ? undefined
        : {
            position: 'bottom',
            text: $t('search.tooltip', brandName())
          }
    "
    :color="showMobileMenu ? 'inverted' : undefined"
  />
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { brandName } from '@/helpers/brand-name';
import { usePageLayoutStore } from '@/stores/page-layout';
import { device } from '@/user-context';

const { showMobileMenu } = storeToRefs(usePageLayoutStore());
</script>
